import React from 'react'
import { Bar } from 'react-chartjs-2'
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js'
import stringToColor from '../utils/stringToColor'
import { SubSource } from '../types/AnalyticsProps'

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend)

interface SubSourcesBarChartProps {
  data: SubSource[]
}

const SubSourcesBarChart: React.FunctionComponent<SubSourcesBarChartProps> = (
  props: SubSourcesBarChartProps,
) => {
  const colors = props.data.map((item) => stringToColor(item.sub_source))

  const chartData = {
    labels: props.data.map((item) => item.sub_source),
    datasets: [
      {
        label: 'Sub Sources',
        data: props.data.map((item) => item.total),
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1,
      },
    ],
  }

  const totalSum = props.data.reduce((acc, item) => acc + item.total, 0)

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            return `${tooltipItem.label}: ${tooltipItem.raw.toLocaleString('en-US')}`
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: false,
        },
        ticks: {
          callback: function (value: any, index: any, values: any) {
            const subSource = props.data[index].sub_source || 'Unknown Sub Source'
            const total = props.data[index].total 
            const percentage = ((total / totalSum) * 100).toFixed(2)
            return `${subSource} - ${percentage}%`
          },
        },
      },
      y: {
        title: {
          display: false,
        },
        beginAtZero: true,
      },
    },
  }

  return (
    <>
      <h4>Sub Sources</h4>
      <Bar data={chartData} options={options} />
    </>
  )
}

export default SubSourcesBarChart
